module.exports = __webpack_public_path__ + "static/media/scenario.5b1c44ac.png";